
import  axios  from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore, loadTowjobDataInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
 


export const LOAD_FAX_DATA = 'fax/LOAD_FAX_DATA';
export const DELETE_A_FAX = 'fax/DELETE_A_FAX';
export const SAVE_A_FAX = 'fax/SAVE_A_FAX';
export const UPDATE_A_FAX = 'fax/UPDATE_A_FAX';
export const LOAD_TOW_FAX_DATA = 'fax/LOAD_TOW_FAX_DATA';
export const SET_FAX_STATUS_FILTER = 'fax/SET_FAX_STATUS_FILTER';
export const SET_FAX_VIN_FILTER = 'fax/SET_FAX_VIN_FILTER';
export const SET_FAX_PLATE_FILTER = 'fax/SET_FAX_PLATE_FILTER';
export const SET_FAX_STARTTIME_FILTER = 'fax/SET_FAX_STARTTIME_FILTER';
export const SET_FAX_ENDTIME_FILTER = 'fax/SET_FAX_ENDTIME_FILTER';
export const SET_FAX_FAX_NUMBER_FILTER = 'fax/SET_FAX_FAX_NUMBER_FILTER';
export const SET_FAX_RECIPIENT_FILTER = 'fax/SET_FAX_RECIPIENT_FILTER';
export const SET_CLEAR_ALL_FILTER = 'fax/SET_CLEAR_ALL_FILTER';
export const CLEAR_A_FAX_ERROR_MESSAGE = 'fax/CLEAR_A_FAX_ERROR_MESSAGE';


export function clearFaxErrorMsgInStore(){
    return {
        type: CLEAR_A_FAX_ERROR_MESSAGE,
        
    }
}

export function loadTowFaxDataInStore(argFaxDataArray) {
    return {
        type: LOAD_TOW_FAX_DATA,
        towFaxsData:argFaxDataArray
    }
}


export function loadFaxDataInStore(argFaxDataArray) {
    return {
        type: LOAD_FAX_DATA,
        faxsData:argFaxDataArray
    }
}
export function deleteAFaxInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_FAX,
        deleteFaxResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAFaxDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_FAX,
        saveFaxResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAFaxDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_FAX,
        updateFaxResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function setFaxStatusFilterInStore(argFilter ) {
    return {
        type: SET_FAX_STATUS_FILTER,
        faxStatusFilter:argFilter,
    }
}

export function setFaxFaxNumberFilterInStore(argFilter ) {
    return {
        type: SET_FAX_FAX_NUMBER_FILTER,
        faxFaxNumberFilter:argFilter,
    }
}

export function setFaxVinFilterInStore(argFilter ) {
    return {
        type: SET_FAX_VIN_FILTER,
        faxVinFilter:argFilter,
    }
}

export function setFaxPlateFilterInStore(argFilter ) {
    return {
        type: SET_FAX_PLATE_FILTER,
        faxPlateFilter:argFilter,
    }
}


export function setFaxRecipientNameFilterInStore(argFilter ) {
    return {
        type: SET_FAX_RECIPIENT_FILTER,
        faxRecipientNameFilter:argFilter,
    }
}

export function setFaxStartTimeFilterInStore(argFilter ) {
    return {
        type: SET_FAX_STARTTIME_FILTER,
        faxStartTimeFilter:argFilter,
    }
}

export function setFaxEndTimeFilterInStore(argFilter ) {
    return {
        type: SET_FAX_ENDTIME_FILTER,
        faxEndTimeFilter:argFilter,
    }
}

export function clearAllFiltersInStore() {
    return {
        type: SET_CLEAR_ALL_FILTER,
        
    }
}

/********************* End of InStore calls **************************/


//****************************************
//Add Fax to the Faxs Array
//****************************************
export function addFaxToFaxsArray(argFax ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempFaxsArray=[] ;
        tempFaxsArray = Object.assign(tempFaxsArray,state.fax.faxsArray);
        //adding to the top of the array.
        tempFaxsArray.unshift(argFax);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadFaxDataInStore(tempFaxsArray));
    }//end of return
}

//****************************************
//Delete Fax from the Faxs Array
//****************************************
export function deleteFaxFromFaxsArray(argFaxId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempFaxsArray=[] ;
        tempFaxsArray = Object.assign(tempFaxsArray,state.fax.faxsArray);
        //removig the match element with the matching id.
        let newArray = tempFaxsArray.filter(element => { return element.id != argFaxId });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadFaxDataInStore(newArray));
    }//end of return
}
//****************************************
//update Fax in the Faxs Array
//****************************************
export function updateFaxInFaxsArray(argFAx ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempFaxsArray=[] ;
        tempFaxsArray = Object.assign(tempFaxsArray,state.fax.faxsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempFaxsArray.filter(element => { return element.id != argFAx.id });
        //adding to the top of the array.
        newArray.unshift(argFAx);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadFaxDataInStore(newArray));
    }//end of return
}


//****************************************
//Below is for update a Stream
//****************************************
export function clearFaxErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearFaxErrorMsgInStore());
    }
}

export function updateAFax(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateAFaxOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateAFaxDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error saving a company" + err.response.data);
            dispatch(updateAFaxDataInStore({}, errorObj));
        });
    }//end of return
}


function updateAFaxOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAFax(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
               // console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAFax(argURL, argFax,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/faxs" ;
    console.log(" on posting a fax the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argFax ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAFax(argURL, argFaxInfo, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveAFaxOnServer(argURL, argFaxInfo, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAFaxDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error saving a storage lot" + err.response.data);
            dispatch(saveAFaxDataInStore({},errorObj));
        });
    }//end of return
}


function saveAFaxOnServer( argURL, argFaxInfo, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAFax(argURL, argFaxInfo, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a fax " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAFax(argURL, argFax, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/"+argFax.towId+"/faxes";
    console.log(" on posting a fax the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argFax ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAFax(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteAFaxOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteAFaxInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAFaxInStore({},errorObj));
        });
    }//end of return
}


function deleteAFaxOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAFax(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
               // console.log("Farshid some error occured on deleteing a Fax " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAFax(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/faxs/"+argStorageId;
    console.log(" on deleteing a Fax the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of faxes

export function loadFaxsData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfFaxs(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadFaxDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfFaxs(argURL,argCompanyId ,argIdToken, argUserId, argTowId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/faxes";
    console.log(" on getting list of Faxs  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfFaxs( argURL, argCompanyId ,argIdToken, argUserId , argTowId){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfFaxs(argURL, argCompanyId ,argIdToken, argUserId, argTowId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                //console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

//Load with filters
export function loadFaxsDataWithFilter(argURL, argCompanyId, argFilter) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfFaxsWithFilter(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id, argFilter).then(function(companysList){
            
            dispatch(loadFaxDataInStore(companysList));
            
        }, function(err){
            console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfFaxsWithFilter(argURL,argCompanyId ,argIdToken, argUserId,  argFilter ){
    /*
     I build something like this :
     http://localhost:4567/company
     */
    
    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/faxes"+argFilter;
    console.log(" on getting list of Faxs  the URL is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


function getListOfFaxsWithFilter( argURL, argCompanyId ,argIdToken, argUserId ,  argFilter){
    
    var returnPromise = new Promise(function(resolve, reject){
        
        var arrayOfGets = [];
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfFaxsWithFilter(argURL, argCompanyId ,argIdToken, argUserId,  argFilter )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
               // console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    
    return returnPromise;
}


//This is for getting fax related to one tow job.

export function loadTowFaxsDataWithFilter(argURL, argCompanyId, argTowId) {
    var filter = "?towid="+argTowId;
    return (dispatch, getState) => {
        const state = getState();
        getListOfFaxsWithFilter(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id, filter).then(function(companysList){
            
            dispatch(loadTowFaxDataInStore(companysList));
            
        }, function(err){
            console.log("I had an error gettting Tow Faxs" + err);
        });
    }//end of return
}


export function setFaxStatusFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxStatusFilterInStore(argStatus));
    }
}


export function setFaxFaxNumberFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxFaxNumberFilterInStore(argStatus));
    }
}

export function setFaxVinFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxVinFilterInStore(argStatus));
    }
}

export function setFaxPlateFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxPlateFilterInStore(argStatus));
    }
}

export function setFaxRecipientNameFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxRecipientNameFilterInStore(argStatus));
    }
}

export function setFaxStartTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxStartTimeFilterInStore(argStatus));
    }
}
export function setFaxEndTimeFilter(argStatus){
    return (dispatch) => {
        dispatch(setFaxEndTimeFilterInStore(argStatus));
    }
}


export function clearAllFilters(){
    return (dispatch) => {
        dispatch(clearAllFiltersInStore());
    }
}
